import GameManager from '../../../core/GameManager';
import { ScenarioSceneType, ScenarioEndType, StepToSkip } from '../../../misc/BleedingControlScenario';
import MainPracticeScenario from './MainPracticeScenario/MainPracticeScenario';
import { constants } from '../../../misc/helpers';
import {getPracticeDScenario} from './practiceStartText';

export default class PracticeScenarioD extends MainPracticeScenario {
	constructor(gameManager: GameManager, scenarioName: string) {
		var locations = [
			{
				type: constants.placementType.wrong,
				position: 53,
			},
			{
				type: constants.placementType.close,
				position: 71,
			},
			{
				type: constants.placementType.correct1,
				position: 29,
			},
		];

		var locations2 = [
			{
				type: constants.placementType.wrong,
				position: 53,
			},
			{
				type: constants.placementType.close,
				position: 71,
			},
			{
				type: constants.placementType.correct1,
				position: 36,
			},
		];

		var correctT1 = 0;
		var correctT2 = 1;
		var wrongT1 = 3;
		var closeT1 = 2;

		super(gameManager, scenarioName, ScenarioSceneType.scenarioD, ScenarioEndType.end, [StepToSkip.steps3And4And5And6], true, 0.28, 0.43, locations, locations2, correctT1, correctT2, wrongT1, closeT1, false, false, false, true, 'Gas Leak Explosion - Practice Scenario', getPracticeDScenario() );
	}

	public get totalNumberOfQuestions(): number {
		return 15;
	}

	public soundFolderAndPath(section: string, part: string): string {
		return '09-Scenario D/BC-Scenario-D-'  + section + '-Part-' + part;
	}
}